export const countEnergyInProduct = (product) =>
    product.weight && product.energy
        ? Math.round((product.energy * product.weight) / 100)
        : 0;

export const countEnergyInDay = (day) =>
    day.protein.reduce(
        (acc, currentVal) => acc + countEnergyInProduct(currentVal),
        0,
    ) +
    day.grocery.reduce(
        (acc, currentVal) => acc + countEnergyInProduct(currentVal),
        0,
    ) +
    day.omegaFats.reduce(
        (acc, currentVal) => acc + countEnergyInProduct(currentVal),
        0,
    ) +
    day.tasty.reduce(
        (acc, currentVal) => acc + countEnergyInProduct(currentVal),
        0,
    ) +
    day.custom.reduce(
        (acc, currentVal) => acc + countEnergyInProduct(currentVal),
        0,
    );
